module.exports = __webpack_public_path__ + "static/media/pinned-tag-grey.b89a3321.svg";